import type { FC } from "react";
import { isEmpty } from "lodash-es";
import { Link } from "@components/cms/link/Link";
import { Box } from "@ui/components/layout/box/Box";
import { Flex } from "@ui/components/layout/flex/Flex";
import { Button } from "@ui/components/forms/button/Button";
import type { ILinksCollection } from "@contentful-api/types/contentful";
import { containerStyles, parentContainerStyles, itemStyles } from "./styles";
import { ECCOIcon } from "@ui/components/media-and-icons/ecco-icon/ECCOIcon";

export interface ICategoryNavigationProps {
    items?: ILinksCollection;
}

export const CategoryNavigation: FC<ICategoryNavigationProps> = ({ items }) => {
    if (isEmpty(items)) return null;

    const links = items?.fields?.links;

    const itemsButtons = links?.map((link) => (
        <Button
            rightIcon={<ECCOIcon name="arrow-right" />}
            as={Link}
            link={link}
            key={link?.sys?.id}
            px={6}
            py={4}
            variant="outline"
        >
            <span>{link?.fields?.label}</span>
        </Button>
    ));

    return (
        <Box sx={parentContainerStyles}>
            <Flex sx={containerStyles}>
                <Flex sx={itemStyles}>{itemsButtons}</Flex>
            </Flex>
        </Box>
    );
};
